const isDark = () => document.documentElement.getAttribute('data-theme') === 'dark'
  || (!document.documentElement.getAttribute('data-theme')
      && window.matchMedia('(prefers-color-scheme: dark)').matches)

export default function ExamWatermark({ name, email }) {
  const text    = `${name}  •  ${email}`
  const rows    = Array.from({ length: 12 }, (_, i) => i)
  const cols    = Array.from({ length: 6  }, (_, i) => i)
  const opacity = isDark() ? 0.04 : 0.06

  return (
    <div
      aria-hidden="true"
      style={{
        position:        'fixed',
        inset:           0,
        pointerEvents:   'none',
        zIndex:          9999,
        overflow:        'hidden',
        transform:       'rotate(-25deg)',
        transformOrigin: 'center center',
        opacity,
      }}
    >
      {rows.map(r => (
        <div key={r} style={{ display: 'flex', gap: '120px', marginBottom: '80px', whiteSpace: 'nowrap' }}>
          {cols.map(c => (
            <span key={c} style={{
              fontSize:   '11px',
              fontWeight: 600,
              color:      'var(--text-1)',
              userSelect: 'none',
              letterSpacing: '0.05em',
            }}>
              {text}
            </span>
          ))}
        </div>
      ))}
    </div>
  )
}
